import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { FirestoreDataService } from '../core/firestore-data.service';
import { VehicleInspection, WorkshopWork } from '../core/models';

interface InspectionViewModel {
  inspection: VehicleInspection;
  work: WorkshopWork;
}

@Component({
  selector: 'app-inspecciones-view',
  templateUrl: './inspecciones-view.component.html',
  styleUrls: ['./inspecciones-view.component.scss'],
  standalone: false
})
export class InspeccionesViewComponent implements OnInit {
  
  inspections: InspectionViewModel[] = [];
  isLoading = true;
  isSearching = false;
  
  searchControl = new FormControl('');
  selectedMonthControl = new FormControl('');
  
  availableMonths: { label: string, value: string }[] = [];

  constructor(
    private firestoreService: FirestoreDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.generateAvailableMonths();
    
    // Carga inicial del mes seleccionado por defecto
    this.loadMonthData();

    // Listener para cuando el usuario cambia el mes en el dropdown
    this.selectedMonthControl.valueChanges.subscribe(() => {
      this.searchControl.setValue('', { emitEvent: false }); // Limpiar la caja de búsqueda
      this.loadMonthData();
    });
  }

  // Genera los últimos 12 meses dinámicamente
  private generateAvailableMonths() {
    const today = new Date();
    for (let i = 0; i < 12; i++) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const value = `${d.getFullYear()}-${d.getMonth() + 1}`;
      let label = d.toLocaleString('es-DO', { month: 'long', year: 'numeric' });
      label = label.charAt(0).toUpperCase() + label.slice(1); // Capitalizar
      this.availableMonths.push({ label, value });
    }
    // Setear el mes actual como seleccionado inicialmente
    if (this.availableMonths.length > 0) {
      this.selectedMonthControl.setValue(this.availableMonths[0].value, { emitEvent: false });
    }
  }

  async loadMonthData() {
    this.isLoading = true;
    this.isSearching = false;
    try {
      const val = this.selectedMonthControl.value;
      if (!val) return;
      const [year, month] = val.split('-').map(Number);
      this.inspections = await this.firestoreService.getInspectionsViewByMonth(year, month);
    } catch (error) {
      console.error("Error cargando inspecciones del mes:", error);
      alert("Hubo un error al cargar las inspecciones.");
    } finally {
      this.isLoading = false;
    }
  }

  // Se activa solo al darle al botón "Buscar" o presionar Enter
  async triggerSearch() {
    const term = this.searchControl.value;
    if (!term || term.trim() === '') {
      this.loadMonthData();
      return;
    }

    this.isLoading = true;
    this.isSearching = true;
    try {
      this.inspections = await this.firestoreService.searchInspectionsFullDB(term);
    } catch (error) {
      console.error("Error en la búsqueda global:", error);
    } finally {
      this.isLoading = false;
    }
  }

  clearSearch() {
    this.searchControl.setValue('');
    this.loadMonthData();
  }

  editInspection(caseNumber: string) {
    this.router.navigate(['/inspection', caseNumber]);
  }

  async deleteInspection(workId: string, caseNumber: string) {
    const confirmation = window.confirm(`¿Estás seguro de que deseas eliminar permanentemente el reporte de inspección para la orden ${caseNumber}?`);
    if (confirmation) {
      try {
        await this.firestoreService.deleteInspection(workId);
        alert('Inspección eliminada correctamente.');
        // Refrescar la lista actual (lo quitamos de la vista en memoria)
        this.inspections = this.inspections.filter(item => item.work.id !== workId);
      } catch (error) {
        console.error("Error eliminando inspección:", error);
        alert('Hubo un error al intentar eliminar la inspección.');
      }
    }
  }
}